module.exports = __webpack_public_path__ + "static/media/PushtimargImage12.4de91f5b.jpg";